module.exports = __webpack_public_path__ + "img/未标题-3-16.ac773364.png";